module.exports = __webpack_public_path__ + "static/media/6-mobile.acd9c31a.jpg";